(ns app.front.ui.collapsible
  (:require
    ["@carbon/icons-react/es/chevron--down/16" :default ChevronDown16]
    ["@carbon/icons-react/es/chevron--up/16" :default ChevronUp16]
    [core.util.util :as util]))

;; --- Primitives -------------------------------------------------------------

(def ^:private status->stripe
  {:default "bg-status-attention"
   :muted   "bg-status-neutral-01"
   :info    "bg-status-neutral-02"
   :warning "bg-status-warning"
   :danger  "bg-status-error"
   :success "bg-status-success"})

(defn divider [] [:div.w-full.h-px.bg-ui-dark-gray])

(defn- left-stripe [{:keys [status]}]
  (let [cls (get status->stripe status)]
    [:div.w-1.5.self-stretch.rounded-tl-sm.rounded-bl-sm {:class cls}]))

(defn card [{:keys [variant extra open?] :or {variant :filled}} & children]
  (into [:div {:class ["w-full rounded border-solid border border-ui-dark-gray"
                       (case variant
                         :border "bg-transparent"
                         (if open? "bg-ui-white" "bg-ui-light-gray"))
                       extra]}]
        children))

(defn header-button
  [{:keys [open? on-toggle id controls extra] :or {id (str (random-uuid))}} & children]
  (into
    [:button.flex.text-left.transition-colors.bg-transparent.p-0.border-0.focus:z-1.focus:shadow-none.focus-visible:shadow-sm
     {:id            id
      :aria-expanded (boolean open?)
      :aria-controls controls
      :on-click      (or on-toggle #())
      ;; keep any passed classes, ensure relative positioning for the chevron
      :class         (str "relative " (or extra ""))
      :type          "button"}]
    children))

(defn caret [open?]
  [:div.absolute.top-1.right-2.w-6.h-6.flex.items-center.justify-center
   (if open?
     [:> ChevronUp16]
     [:> ChevronDown16])])

;; --- High-level -------------------------------------------------------------

(defn collapsible
  "Props:
   - :open?     boolean
   - :on-toggle fn
   - :variant   :filled | :border
   - :status    :default | :muted | :info | :warning | :danger | :success
   - :header    hiccup (left)
   - :header-id :body-id strings
   - :footer    hiccup (optional)"
  [{:keys [open? on-toggle variant status header header-id body-id footer]} & children]
  [card (util/mmap variant open?)
   [:div.flex.min-w-0
    (when status [left-stripe {:status status}])
    [:div.flex-1.min-w-0.flex.flex-col.items-stretch
     [header-button {:open? open? :on-toggle on-toggle :id header-id :controls body-id}
      [:div.flex.flex-1.items-start.justify-between.gap-2.min-w-0
       header
       [caret open?]]]
     ;; Divider directly under header, visible in both collapsed and expanded states
     [divider]
     (when open?
       [:<>
        (into [:div.min-w-0 {:id body-id}] children)
        (when footer
          [:<>
           [divider]
           footer])])]]])
